import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { RestoreService } from "./restore.service";
import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { BaseComponent } from "@bt/core/base";
import { Validators, EmailValidator, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { UserService } from "@bt/core";
import { NotifierService } from 'angular-notifier';
import { Router } from "@angular/router";

library.add(fas, far);
library.add(faCheckCircle);
library.add(faTimesCircle);

@Component({
  selector: 'app-restore',
  templateUrl: './restore.component.html',
  styleUrls: ["./restore.component.scss"]
})
export class RestoreComponent extends BaseComponent {
  public showLoader: boolean = false;
  public emailRestore: string;
  public restoreForm: FormGroup;
  public textError: string;

  constructor(private service: RestoreService, private fb: FormBuilder,
    private userService: UserService,
    private router: Router,
    private notifier: NotifierService) {
    super();
  }

  public restore() {
    var t = this
    t.setLoading(true);
    this.userService.forgotPassword(t.emailRestore)
      .subscribe((resp) => {
        this.notifier.notify('success', 'Запрос на изменение пароля отправлен');
        t.setLoading(false);
        this.router.navigateByUrl("app/login")

      }, (error) => {
        t.textError = error.error.errorMsgs[0];
        if(t.textError=="User not found")
        {
          t.textError="Пользователь не найден"
        }
        var alert = document.getElementsByClassName("myalert");
        (<any>alert[0]).style.display = "block";
        setTimeout(function () { (<any>alert[0]).style.display = "none"; }, 4000)
        t.setLoading(false);
      })
  }

  get email() { return this.restoreForm.get('email'); }

  public ngOnInit() {
    this.restoreForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]]
    });


  }

  goBack() {
    this.router.navigateByUrl('app/login');
  }
}



// WEBPACK FOOTER //
// ./src/app/public/restore/restore.component.ts